/**
 * Devuelve un objeto con el estado inicial para la paginación
 * @returns {Object} Estado inicial de paginación con propiedades y métodos
 */
const getDefaultPagingState = () => ({
    count: 0,
    end: 0,
    next: null,
    previous: null,
    size: 25,
    start: 0,
    page: 1,
    pages: 0,
    getParams: function () {
        return {
            page: this.page,
            size: this.size,
        };
    },
    getPages: function () {
        return this.pages > 1 ? `${this.page}/${this.pages}` : 1;
    },
    getPlace: function () {
        return this.pages > 1 ? `${this.start + 1} - ${this.end}` : "";
    },
});

/**
 * Crea un modelo de paginación con propiedades y funciones predeterminadas
 * @returns {Object} Modelo de paginación
 */
const createFetcher = () => ({
    active: false,
    paging: null,
    handleCallApi: () => {
    },
});
const PagerModel = function () {

    this.active = false
    this.paging = {
        count: 0,
        end: 0,
        next: null,
        previous: null,
        size: 25,
        start: 0,
        page: 1,
        pages: 0,
        getParams: function () {
            return {
                page: this.page,
                size: this.size,
            };
        },
        getPages: function () {
            return this.pages > 1 ? `${this.page}/${this.pages}` : 1;
        },
        getPlace: function () {
            return this.pages > 1 ? `${this.start + 1} - ${this.end}` : "";
        },
        update: function (pager) {
            Object.assign(this, pager);
        },
        setPager: function (data) {
            if(data && data.pager){
                Object.assign(this, data.pager);
            }
        }

    }
    this.handleCallApi = () => {
    }
    this.reset = function () {
        this.paging.count = 0;
        this.paging.end = 0;
        this.paging.next = null;
        this.paging.previous = null;
        this.paging.size = 25;
        this.paging.start = 0;
        this.paging.page = 1;
        this.paging.pages = 0;
    }
}

export {
    getDefaultPagingState,
    createFetcher,
    PagerModel,
};
